import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { userInfoAtom } from '~atoms';
import { SkcNfcTagsOverviewContainer } from '~features/access';

import Page from '../page';

const AccessRulesPage = () => {
	const { t } = useTranslation();

	const [userInfo] = useAtom(userInfoAtom);

	return (
		<Page title={t('accessTags')}>
			<SkcNfcTagsOverviewContainer />
		</Page>
	);
};

export default AccessRulesPage;
